export const t = {
  fa: {
    // Navbar
    home: "خانه",
    contacts: "مخاطبین",
    search: "جستجو",
    categories: "دسته‌بندی‌ها",
    signOut: "خروج",

    // Home
    greeting: "خوش آمدید",
    greetingSub: "این خلاصه دفترچه تلفن شما است.",
    totalContacts: "کل مخاطبین",
    addedToday: "امروز اضافه شده",
    workContacts: "مخاطبین کاری",
    family: "خانواده",
    recentlyAdded: "اخیراً اضافه شده",
    noContacts: "هنوز مخاطبی ندارید",

    // Contacts
    addNew: "افزودن مخاطب جدید",
    fullName: "نام و نام خانوادگی",
    phoneNumber: "شماره تلفن",
    category: "دسته‌بندی",
    addContact: "+ افزودن مخاطب",
    edit: "ویرایش",
    delete: "حذف",
    editContact: "ویرایش مخاطب",
    saveChanges: "ذخیره تغییرات",
    cancel: "انصراف",

    // Search
    searchPlaceholder: "جستجو بر اساس نام یا شماره...",
    all: "همه",
    results: "نتیجه",
    totalCount: "کل مخاطبین",
    noResults: "نتیجه‌ای یافت نشد",

    // Categories
    friends: "دوستان",
    work: "کاری",
    other: "سایر",
    noContactsInCat: "مخاطبی در این دسته‌بندی وجود ندارد",

    // Visibility
    visibilityLabel: "سطح دسترسی",
    visibility1: "محرمانه (فقط مدیران)",
    visibility2: "نیمه محرمانه",
    visibility3: "عمومی شرکت",
    visibility4: "همه",

    // Contact Detail
    back: "‹ بازگشت",
    phone: "تلفن",
    addedOn: "تاریخ افزودن",
    save: "✓ ذخیره",
    deleteConfirm: "آیا از حذف این مخاطب اطمینان دارید؟",

    // Auth
    welcomeBack: "خوش برگشتید",
    signInSub: "وارد حساب کاربری خود شوید",
    email: "ایمیل",
    password: "رمز عبور",
    signIn: "ورود",
    signingIn: "در حال ورود...",
    noAccount: "حساب کاربری ندارید؟",
    register: "ثبت‌نام",
    createAccount: "ایجاد حساب کاربری",
    createAccountSub: "مدیریت مخاطبین خود را شروع کنید",
    confirmPassword: "تأیید رمز عبور",
    creating: "در حال ایجاد...",
    hasAccount: "قبلاً ثبت‌نام کرده‌اید؟",
    passwordMismatch: "رمز عبور مطابقت ندارد",
    passwordShort: "رمز عبور باید حداقل ۶ کاراکتر باشد",
  },

  en: {
    // Navbar
    home: "Home",
    contacts: "Contacts",
    search: "Search",
    categories: "Categories",
    signOut: "Sign out",

    // Home
    greeting: "Good to see you",
    greetingSub: "Here's what's in your address book today.",
    totalContacts: "Total contacts",
    addedToday: "Added today",
    workContacts: "Work contacts",
    family: "Family",
    recentlyAdded: "Recently added",
    noContacts: "No contacts yet",

    // Contacts
    addNew: "Add new contact",
    fullName: "Full name",
    phoneNumber: "Phone number",
    category: "Category",
    addContact: "+ Add Contact",
    edit: "Edit",
    delete: "Delete",
    editContact: "Edit Contact",
    saveChanges: "Save Changes",
    cancel: "Cancel",

    // Search
    searchPlaceholder: "Search by name or phone...",
    all: "All",
    results: "result",
    totalCount: "total contacts",
    noResults: "No results found",

    // Categories
    friends: "Friends",
    work: "Work",
    other: "Other",
    noContactsInCat: "No contacts in this category",

    // Contact Detail
    back: "‹ Back",
    phone: "Phone",
    addedOn: "Added on",
    save: "✓ Save",
    deleteConfirm: "Delete this contact?",

    // Auth
    welcomeBack: "Welcome back",
    signInSub: "Sign in to your account",
    email: "Email",
    password: "Password",
    signIn: "Sign in",
    signingIn: "Signing in...",
    noAccount: "Don't have an account?",
    register: "Register",
    createAccount: "Create account",
    createAccountSub: "Start managing your contacts",
    confirmPassword: "Confirm password",
    creating: "Creating account...",
    hasAccount: "Already have an account?",
    passwordMismatch: "Passwords don't match",
    passwordShort: "Password must be at least 6 characters",
     // Visibility
    visibilityLabel: "Access Level",
    visibility1: "Confidential (Managers only)",
    visibility2: "Semi-confidential",
    visibility3: "Company-wide",
    visibility4: "Everyone",
  },
};